import styled from 'styled-components';

const EBarMemberCenterResultDiv = styled.div`
  width: 100%;
`;

EBarMemberCenterResultDiv.displayName = 'EBarMemberCenterResultDiv';

export default EBarMemberCenterResultDiv;
